import { apiClient } from "./client";
import type { LoginResponse } from "@/types";

interface LoginCredentials {
  email: string;
  password: string;
}

/**
 * Authentication API service
 */
export const authService = {
  /**
   * Authenticates user and returns JWT access token
   */
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    return apiClient.post<LoginResponse>("/auth/login", credentials);
  },
};
